export const topicsData = [
  { id: 1, name: '明星恋情', hot: true, count: '128万', color: 'bg-primary-500' },
  { id: 2, name: '综艺翻车', hot: true, count: '96万', color: 'bg-accent-500' },
  { id: 3, name: '网红塌房', hot: true, count: '87万', color: 'bg-secondary-500' },
  { id: 4, name: '影视吐槽', hot: false, count: '65万', color: 'bg-primary-400' },
  { id: 5, name: '婚变风波', hot: true, count: '112万', color: 'bg-accent-400' },
  { id: 6, name: '选秀内幕', hot: false, count: '43万', color: 'bg-secondary-400' },
  { id: 7, name: '饭圈大战', hot: true, count: '156万', color: 'bg-primary-500' },
  { id: 8, name: '代言翻车', hot: false, count: '38万', color: 'bg-accent-300' },
  { id: 9, name: '私生爆料', hot: true, count: '71万', color: 'bg-secondary-500' },
  { id: 10, name: '综艺路透', hot: false, count: '52万', color: 'bg-primary-300' },
];

export const rankingData = [
  { rank: 1, title: '顶流小生深夜密会神秘女子，工作室火速辟谣反被扒细节', heat: '🔥 286万热度', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名导演被曝剧组潜规则，多位女演员联合发声', heat: '🔥 234万热度', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '某选秀冠军涉嫌税务问题，工作室回应正在配合调查', heat: '🔥 198万热度', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '当红花旦与经纪公司解约内幕曝光，涉及天价违约金', heat: '🔥 167万热度', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '综艺录制现场发生争执，两位常驻嘉宾疑似结怨已久', heat: '🔥 145万热度', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 6, title: '知名歌手新歌被指抄袭，原作者发声要求下架并道歉', heat: '🔥 123万热度', tag: '', tagColor: '' },
  { rank: 7, title: '某品牌代言人突然被换，背后资本博弈浮出水面', heat: '🔥 98万热度', tag: '', tagColor: '' },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7×24小时不间断更新，第一时间捕捉娱乐圈风吹草动，让你永远快人一步掌握一手爆料。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '安全访问',
    desc: '多重加密保障浏览安全，全网最新地址实时同步，让你随时随地无忧访问吃瓜平台。',
  },
  {
    id: 3,
    icon: 'ri-spy-line',
    title: '独家深扒',
    desc: '资深娱记深度挖掘内幕，从蛛丝马迹中还原事件真相，给你最全面的吃瓜体验。',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '某顶流被曝隐婚生子，妻子身份竟是圈外人',
    summary: '据知情人士透露，该艺人已秘密完婚三年，孩子已满两岁，此前从未有任何风声传出。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20magazine%20style%20with%20warm%20coral%20and%20peach%20gradients%2C%20soft%20dramatic%20lighting%2C%20mysterious%20vibe%2C%20editorial%20photography%20aesthetic%20with%20dark%20silhouettes%20and%20bold%20typography%20space%2C%20minimalist%20composition&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '独家',
  },
  {
    id: 2,
    title: '综艺录制突遇意外，节目组紧急叫停引热议',
    summary: '某热门综艺最新一期录制过程中发生舞台事故，一名嘉宾受伤送医，节目组已发声明致歉。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20lighting%20with%20warm%20amber%20and%20coral%20tones%2C%20abstract%20performance%20atmosphere%2C%20spotlight%20beams%20cutting%20through%20darkness%2C%20editorial%20entertainment%20photography%20style%2C%20clean%20minimal%20composition%20with%20negative%20space&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '热闻',
  },
  {
    id: 3,
    title: '知名导演新片选角陷入争议，粉丝集体抵制',
    summary: '该导演最新作品选角公布后引发大规模讨论，原著粉丝认为选角与角色设定严重不符。',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20soundstage%20with%20dramatic%20warm%20spotlight%2C%20cinematic%20atmosphere%20with%20coral%20and%20deep%20shadow%20contrast%2C%20editorial%20composition%2C%20minimalist%20movie%20set%20aesthetic&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '争议',
  },
  {
    id: 4,
    title: '某女星深夜发文疑似回应婚变，随后秒删',
    summary: '这条深夜动态包含大量情绪化内容，粉丝截图后迅速在网上传开，引发全网猜测。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20glowing%20in%20dark%20room%20with%20warm%20ambient%20light%2C%20late%20night%20vibe%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20with%20soft%20coral%20color%20grading%2C%20minimalist%20composition&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '热议',
  },
  {
    id: 5,
    title: '选秀节目投票数据遭质疑，节目组公布后台记录',
    summary: '粉丝发现投票数据存在异常波动，节目组紧急公布原始数据自证清白，但仍有疑点未解。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20gradient%20bars%20and%20charts%2C%20modern%20infographic%20aesthetic%2C%20coral%20and%20amber%20tones%2C%20clean%20minimal%20design%2C%20editorial%20style%20with%20soft%20dramatic%20lighting&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '追踪',
  },
  {
    id: 6,
    title: '某偶像团体成员疑似恋情曝光，站姐放出实锤',
    summary: '长期跟拍的站姐放出多张疑似约会照，照片中两人举止亲密，粉丝群体已出现分化。',
    image: 'https://readdy.ai/api/search-image?query=Blurred%20street%20photography%20with%20warm%20evening%20light%2C%20paprazzi%20aesthetic%2C%20two%20silhouettes%20in%20soft%20focus%2C%20urban%20night%20vibe%2C%20editorial%20style%20with%20coral%20and%20amber%20color%20grading%2C%20mysterious%20mood&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '实锤',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '【深度】娱乐圈资本局：一场选秀背后的商业博弈',
    duration: '15:42',
    views: '89万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20charts%20and%20entertainment%20elements%20blending%20together%2C%20warm%20coral%20and%20gold%20gradients%2C%20modern%20business%20aesthetic%20with%20creative%20flair%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '【扒皮】某流量明星真实背景大起底',
    duration: '22:18',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20abstract%20documents%20with%20warm%20dramatic%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20coral%20and%20amber%20tones%2C%20mysterious%20and%20sophisticated%20mood%2C%20editorial%20composition&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '【盘点】今年最让人意想不到的十大反转事件',
    duration: '18:55',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20contrast%20between%20light%20and%20shadow%20with%20warm%20coral%20and%20dark%20tones%2C%20twist%20and%20turn%20visual%20metaphor%2C%20abstract%20maze%20or%20zigzag%20pattern%2C%20editorial%20style%2C%20clean%20minimal%20composition&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const updatesData = [
  { id: 1, time: '10分钟前', content: '某选秀节目导师阵容疑似确定，三位重量级艺人正在洽谈中', badge: '最新', badgeColor: 'bg-primary-500' },
  { id: 2, time: '28分钟前', content: '知名歌手演唱会突发设备故障，现场即兴清唱获全场好评', badge: '热议', badgeColor: 'bg-accent-500' },
  { id: 3, time: '1小时前', content: '某影视公司发布年度片单，多部热门IP改编作品确认立项', badge: '', badgeColor: '' },
  { id: 4, time: '2小时前', content: '当红小生被拍到出入高档小区，疑似购置新豪宅', badge: '', badgeColor: '' },
  { id: 5, time: '3小时前', content: '某综艺节目录制路透曝光，飞行嘉宾阵容引发期待', badge: '', badgeColor: '' },
  { id: 6, time: '5小时前', content: '著名编剧发文暗讽某流量艺人，随后删除动态引猜测', badge: '跟进', badgeColor: 'bg-secondary-500' },
  { id: 7, time: '7小时前', content: '某品牌官宣新代言人，粉丝应援活动已全面启动', badge: '', badgeColor: '' },
];

export const commentsData = [
  {
    id: 1,
    avatar: '匿',
    name: '吃瓜群众甲',
    time: '3小时前',
    content: '这个瓜我吃了三天了，越吃越有味道！每一条新料都让人大跌眼镜，建议大家都来复盘一下时间线。',
    likes: '2.3K',
  },
  {
    id: 2,
    avatar: '瓜',
    name: '资深猹',
    time: '5小时前',
    content: '作为混圈十年的老粉，我只能说这次爆料的深度远超以往。圈内人都知道的事终于被捅出来了。',
    likes: '1.8K',
  },
  {
    id: 3,
    avatar: '吃',
    name: '田野调查员',
    time: '8小时前',
    content: '理性吃瓜，坐等更多实锤。目前的信息碎片还不够拼出完整画像，建议大家不要急着站队。',
    likes: '956',
  },
  {
    id: 4,
    avatar: '看',
    name: '火眼金睛',
    time: '12小时前',
    content: '补一个瓜：知情人士透露还有更大的料在后面，涉及多位艺人和资本方，预计本周内会有新进展。',
    likes: '3.1K',
  },
];

export const faqData = [
  {
    id: 1,
    q: '吃瓜官网是什么平台？',
    a: '吃瓜官网是专业的娱乐资讯与八卦爆料聚合平台，汇集全网最新最热的娱乐圈动态、明星资讯和独家爆料内容，致力于为广大网友提供安全、及时、全面的吃瓜体验。',
  },
  {
    id: 2,
    q: '如何找到吃瓜官网最新地址？',
    a: '请收藏并记住我们的官方标识和域名特征，本页面即为官方首页入口。如遇访问问题，可关注我们的社交媒体官方账号获取最新入口信息，确保访问的是吃瓜官方网站。',
  },
  {
    id: 3,
    q: '平台上的爆料内容可信吗？',
    a: '我们坚持多方信源交叉验证原则，所有标注"独家"的内容均经过内部核实流程。同时我们会清晰区分实锤爆料和网络传闻，让读者能够自行判断信息可信度。',
  },
  {
    id: 4,
    q: '可以投稿或爆料吗？',
    a: '欢迎通过页面上方的投稿入口提交您的独家线索。我们承诺保护爆料人的隐私安全，所有投稿信息均经过严格加密处理，确保您的身份不会泄露。',
  },
  {
    id: 5,
    q: '平台更新频率是怎样的？',
    a: '我们保持7×24小时全天候运营，编辑团队实时追踪娱乐圈动态，确保重大事件发生后的第一时间为您推送最新进展，让您不错过任何精彩内容。',
  },
  {
    id: 6,
    q: '手机端如何访问吃瓜官网？',
    a: '吃瓜官网已全面适配移动端，您可以直接在手机浏览器中访问本页面获得流畅的浏览体验。我们也在持续优化移动端的阅读体验，敬请期待更多功能。',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '娱乐圈上半年大盘点：十大震撼事件全回顾',
    desc: '从顶流翻车到世纪和解，2026上半年娱乐圈风起云涌，带你一文看尽所有不容错过的精彩时刻。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20red%20carpet%20stage%20with%20warm%20coral%20and%20gold%20ambient%20lighting%2C%20entertainment%20awards%20show%20aesthetic%2C%20grand%20and%20dramatic%20atmosphere%2C%20editorial%20photography%20style%2C%20wide%20cinematic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
  },
  {
    id: 2,
    title: '独家深扒：某娱乐集团内部权力更迭全记录',
    desc: '高层换血、艺人出走、资本重组，一家娱乐巨头如何在半年内经历翻天覆地的变化。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20boardroom%20with%20empty%20chairs%20and%20dramatic%20lighting%2C%20power%20and%20intrigue%20visual%20metaphor%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20editorial%20style%20with%20sophisticated%20mood&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '独家策划',
  },
  {
    id: 3,
    title: '选秀十年：那些从素人到顶流的蜕变故事',
    desc: '十年间无数素人通过选秀走进大众视野，有人一路高歌，有人昙花一现，一起回顾那些改变命运的舞台瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20talent%20show%20stage%20with%20dramatic%20spotlights%20and%20confetti%20falling%2C%20warm%20coral%20and%20gold%20lighting%2C%20grand%20entertainment%20aesthetic%2C%20wide%20cinematic%20composition%2C%20celebration%20mood&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '专题回顾',
  },
  {
    id: 4,
    title: '饭圈文化大观察：追星方式的十年变迁',
    desc: '从贴吧签到到超话打榜，从线下应援到线上控评，饭圈文化经历了怎样的演变？未来又将走向何方？',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20crowd%20of%20light%20sticks%20and%20fan%20banners%20in%20dark%20arena%2C%20warm%20coral%20and%20vibrant%20accent%20colors%2C%20concert%20atmosphere%2C%20editorial%20style%2C%20dynamic%20composition%20with%20sense%20of%20community&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '深度观察',
  },
  {
    id: 5,
    title: '影视寒冬中的逆袭者：小成本爆款做对了什么',
    desc: '当大制作频频翻车，一些不起眼的小成本作品却意外走红，它们背后的创作密码值得整个行业深思。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20film%20clapperboard%20with%20warm%20dramatic%20lighting%20on%20minimalist%20set%2C%20independent%20cinema%20aesthetic%2C%20coral%20and%20amber%20tones%2C%20artistic%20composition%2C%20creative%20and%20inspiring%20mood&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '行业分析',
  },
  {
    id: 6,
    title: '明星副业大盘点：谁的商业版图最让人意外',
    desc: '开餐厅、做潮牌、搞投资，明星们不拍戏的时候都在忙什么？揭秘娱乐圈隐藏的商业帝国。',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20storefront%20and%20business%20elements%20blending%20with%20entertainment%20aesthetic%2C%20warm%20gold%20and%20coral%20gradients%2C%20sophisticated%20commercial%20photography%20style%2C%20glamorous%20yet%20minimal%20composition&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '趣味盘点',
  },
];

export const indexData = [
  { id: 1, title: '明星恋情追踪', count: '326篇', icon: 'ri-heart-line', desc: '最新明星情感动态全收录' },
  { id: 2, title: '综艺幕后揭秘', count: '218篇', icon: 'ri-tv-line', desc: '热门综艺不为人知的台前幕后' },
  { id: 3, title: '影视深度吐槽', count: '187篇', icon: 'ri-film-line', desc: '新片老片一网打尽的精彩点评' },
  { id: 4, title: '饭圈动态速递', count: '265篇', icon: 'ri-group-line', desc: '各家粉丝圈的最新动向汇总' },
  { id: 5, title: '商业代言观察', count: '143篇', icon: 'ri-shopping-bag-line', desc: '明星代言与品牌合作全解析' },
  { id: 6, title: '法律法规科普', count: '89篇', icon: 'ri-scales-line', desc: '娱乐圈相关法律知识普及' },
  { id: 7, title: '每周吃瓜总结', count: '52篇', icon: 'ri-file-list-line', desc: '一周精彩内容不遗漏' },
];

export const heroStats = [
  { label: '每日更新', value: '200+' },
  { label: '独家爆料', value: '5000+' },
  { label: '活跃用户', value: '860万' },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '平台特色', href: '#features' },
  { label: '热门话题', href: '#topics' },
  { label: '关于我们', href: '#about' },
  { label: '专题索引', href: '#index' },
  { label: '热度榜单', href: '#ranking' },
];

export const siteInfo = {
  name: '吃瓜官网',
  slogan: '娱乐圈一手爆料平台',
  description: '吃瓜官网是专业娱乐资讯与八卦爆料聚合平台，为您提供51吃瓜官网首页进入、吃瓜网站最新地址及51吃瓜官方入口。我们7×24小时追踪娱乐圈动态，汇聚全网最新最热的明星八卦、综艺爆料、影视吐槽和独家深扒内容，安全直达吃瓜平台首页，畅享八卦爆料。无论您是资深吃瓜群众还是偶尔围观的过客，都能在这里找到最对味的娱乐大餐。',
};